var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,12a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,8,12ZM8,7.875A1.125,1.125,0,1,0,9.125,9,1.12611,1.12611,0,0,0,8,7.875ZM15.5,10A3.5,3.5,0,1,1,19,6.5,3.50424,3.50424,0,0,1,15.5,10Zm0-5A1.5,1.5,0,1,0,17,6.5,1.50164,1.50164,0,0,0,15.5,5ZM17,11H14a3.98009,3.98009,0,0,0-3.46,2H7a3.999,3.999,0,0,0-4,4v4H21V15A3.99891,3.99891,0,0,0,17,11ZM5,19V17a2.00583,2.00583,0,0,1,2-2h3v4Zm14,0H12V15a2.00583,2.00583,0,0,1,2-2h3a2.00579,2.00579,0,0,1,2,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPeople);
export default __webpack_public_path__ + "static/media/Group-people.a22470bd.svg";
export { ForwardRef as ReactComponent };